import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BoardReductionGoal } from '../../model/board-reduction-goal';
import { ClientBoard } from '../../model/client-model/client-board';
import { ErrorType } from '../../services/error-handler.service';

export type RecursiveKeyOf<T> = T extends object
  ? T extends readonly any[]
    ? RecursiveKeyOf<T[number]>
    : T extends Date
      ? never
      : keyof T | RecursiveKeyOf<T[keyof T]>
  : never;

type RecursiveValueOf<T> = T extends object
  ? T extends readonly any[]
    ? RecursiveValueOf<T[number]>
    : T extends Date
      ? Date
      : T[keyof T] | RecursiveValueOf<T[keyof T]>
  : never;

export type RecursivePropOfBoard = RecursiveKeyOf<ClientBoard>[];
export type RecursiveValueOfBoard = RecursiveValueOf<ClientBoard>;

export const boardEffectsActions = createActionGroup({
  source: 'Board Effects',
  events: {
    'Set board': props<{ board: ClientBoard }>(),
    'Board loaded': emptyProps(),
    'Board loading error': props<{ error: Error & { errorType: ErrorType } }>(),
    'Board save complete': props<{ board: ClientBoard }>(),
    'Board save error': props<{ error: Error & { errorType: ErrorType } }>(),
    'Board delete complete': props<{ boardId: string; tenantId: string }>(),

    'Create reduction goal complete': props<{ boardReductionGoal: BoardReductionGoal }>(),
    'Update reduction goal complete': props<{ boardReductionGoal: BoardReductionGoal }>(),
    'Delete reduction goal complete': props<{ boardReductionGoal: Pick<BoardReductionGoal, 'id'> }>(),
  },
});

export const boardFacadeActions = createActionGroup({
  source: 'Board Facade',
  events: {
    'Clear board store': emptyProps(),
    'Load board': emptyProps(),
    'Save board': props<{ updates: { property: RecursivePropOfBoard; value: RecursiveValueOfBoard }[] }>(),
    'Delete board': props<{ boardId: string; tenantId: string }>(),
    'Update eTag and childNodes': props<{ _etag: string; childNodes: string[] }>(),

    'Create reduction goal': props<{ boardReductionGoal: Omit<BoardReductionGoal, 'id'> }>(),
    'Update reduction goal': props<{ boardReductionGoal: BoardReductionGoal }>(),
    'Delete reduction goal': props<{ boardReductionGoal: Pick<BoardReductionGoal, 'id'> }>(),
  },
});
